import { schema } from "normalizr";
export const email = new schema.Entity("email");
export const emailsSchema = new schema.Entity("emails", {
  emails: [email]
}, {
  idAttribute: "nylasAccountId"
});
export const calendar = new schema.Entity("calendar");
export const calendarsSchema = new schema.Entity("calendars", {
  calendars: [calendar]
}, {
  idAttribute: value => `${value.nylasAccountId}-${value.calendarId}`
});